import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Skeleton } from '@/components/ui/skeleton';

const ProtectedRoute = ({ children, skipEmailCheck = false, requireRole = null }) => {
  const { isAuthenticated, loading, user } = useAuth();
  const location = useLocation();
  
  if (loading) {
    return (
      <div className="container-custom py-6 space-y-6">
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-32 w-full" />
        <Skeleton className="h-32 w-full" />
      </div>
    );
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check role if required
  if (requireRole && user) {
    const allowedRoles = Array.isArray(requireRole) ? requireRole : [requireRole];
    if (!allowedRoles.includes(user.role)) {
      // Unauthorized: redirect to home
      return <Navigate to="/accueil" replace />;
    }
  }

  // Redirect to email verification interstitial if email is not verified
  // Skip this check for the interstitial page itself, profile page, and dev tools
  // Also skip if user already dismissed the interstitial this session
  const emailSkipped = typeof window !== 'undefined' && sessionStorage.getItem('nannyou_email_skip') === '1';
  if (
    !skipEmailCheck &&
    !emailSkipped &&
    user &&
    user.email_verified === false &&
    location.pathname !== '/verifier-email' &&
    location.pathname !== '/profil' &&
    location.pathname !== '/dev'
  ) {
    return <Navigate to="/verifier-email" replace />;
  }
  
  return children;
};

export default ProtectedRoute;
